export const X_FIELD = 'x';
export const Y_FIELD = 'y';
export const COLOR_FIELD = 'name';
